import { channelsList } from "../../utils/channelsList";
import { RadioChannels } from "./styled";
import RadioChannelCard from "../RadioChannelCard";

export const RadioChannelsList = () => {
  return (
    <RadioChannels>
      {channelsList.map((channel) => (
        <RadioChannelCard channel={channel} key={channel.type} />
      ))}
    </RadioChannels>
  );
};
